import useGetGeneralSettings from "../../../providers/useGetGeneralSettings";
import {getActiveMembership} from "@src/components/Common/utils";


/**
 * The declaration keyed by the name the team goes by now.
 *
 * A declaration's top-level key is the team's name, and both of the things the
 * builder starts from carry the name as it was when they were written: the last
 * submission, and the work in progress kept in local storage. A team renamed
 * since then would otherwise open a declaration keyed by a name the API no
 * longer knows — the builder would find nothing under the current name and
 * offer an empty declaration, and submitting it would read as deleting every
 * service item the team has.
 *
 * A submission carries exactly one team, so only a one-key declaration is
 * re-keyed; anything else is left alone rather than guessed at. The same object
 * is returned when there is nothing to do, so the caller can tell.
 */
export const rekeyDeclaration = (declaration: any, teamName?: string) => {
    if (!teamName || !declaration || typeof declaration !== 'object') return declaration;

    const keys = Object.keys(declaration);
    if (keys.length !== 1 || keys[0] === teamName) return declaration;

    return { [teamName]: declaration[keys[0]] };
};

export const isSubmitButtonVisible = () => {
    const generalSettings = useGetGeneralSettings();
    const activeMembership = getActiveMembership()

    const submissionBuilderSettings = generalSettings.find(setting => setting.name == 'SubmissionBuilder');
    const visibleFromGeneralSettings = submissionBuilderSettings?.config?.enable_submit_functionality
    const visibleFromTeamPreferences = activeMembership?.team?.preferences?.allow_submit_submission_builder

    return visibleFromGeneralSettings && visibleFromTeamPreferences
}
